<template>
    <router-link :to="{path: path}" v-if="!isExternal" 
                v-slot="{ href, route, navigate, isActive, isExactActive }" :exact="path === '/'"> 
        <li :class="[isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
            <a :href="route.path" v-html="title" class="hidden" :data-category="dataCategory" 
            :data-label="title"  @click="clickPath($event, navigate, route.path, false)"/>
        </li>
    </router-link>   
    <li v-else>
        <a :href="path" v-html="title" target="_blank" @click="clickPath($event, null, path, true)"></a>
    </li>
</template>

<script>
export default {
    props: {    
        title:  {
            type: String
        },
        path:  {
            type: String           
        },
        dataCategory: {
            type: String
        }
    },
    computed: {
        isExternal(){
            return this.path != null && this.path.startsWith('http')
        }
    },
    methods: {
        clickPath(e, routeHandler, path, isExternal) {
            this.$emit('navigate', { type: 'routeLink', path: path, isExternal: isExternal})
            if (routeHandler) {
                routeHandler(e)
            }
        }
    }
}
</script>